<template>
   <div>
    <module-card title="">
      <el-form inline :model="searchForm">
        <el-form-item label="导出文档名称：">
          <el-select v-model="searchForm.templateType" class="form-select">
            <el-option v-for="item in exportDocumentNameList" :label="item.name" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item >
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="searchBtnClick"
            :loading="searchLoading"
          >查询</el-button>
        </el-form-item>
      </el-form>
      <el-table border :data="tableData" v-loading="searchLoading">
        <el-table-column v-for="(item,index) in columns" :prop="item.key" :label="item.label" :key="index"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <div>
              <el-button type="text" @click="checkDetail(scope.row)">详情</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </module-card>
   </div>
</template>

<script>
export default {
  components: {},

  data () {
    return {
      searchLoading: false,
      searchForm: {
        templateType: ''
      },
      exportDocumentNameList: [
        { name: '全部', value: '' },
        { name: '导出已绑卡【商户资料】', value: 1 }
      ],
      columns: [
        { label: '功能页面', key: 'pageName' },
        { label: '导出文档名称', key: 'templateTypeName' },
        { label: '模板数量', key: 'templateCount' }
      ],
      tableData: []
    }
  },

  computed: {},

  created () {
    this.searchBtnClick()
  },

  mounted () {},

  methods: {
    searchBtnClick () {
      this.searchLoading = true
      this.$axios.post(this.$api.getDocList, {
        templateType: this.searchForm.templateType
      }).then(res => {
        this.searchLoading = false
        if (res.respCode === '0') {
          this.tableData = res.data
        } else {
          this.tableData = []
        }
      })
    },
    checkDetail (row) {
      this.$router.push({
        path: '/fileManage/exportTemplateDetail',
        query: {
          type: row.templateType
        }
      })
    }
  }
}
</script>
<style lang="css" scoped>
.form-select{
  width:300px
}
</style>
